module.exports = __webpack_public_path__ + "static/media/logo_footer.4ea4418c.svg";